module.exports = __webpack_public_path__ + "static/img/klosterforst.9a8c36c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ITZ_Klosterforst/klosterforst.jpg
// module id = fV6z
// module chunks = 0